import styled from "styled-components";
import { Paragraph } from "../../general/Paragraph/Paragraph";
import { size } from "../../../style/util/size";
import { device, hover } from "../../../style/util/media-query";
import { Button } from "../../general/buttons/Button/Button";
import { zIndex } from "../../../style/util/z-index";
import { Icon } from "../../general/Icon/Icon";
import { easeOut, rgba } from "polished";
import { GlascLogo } from "../../general/GlascLogo/GlascLogo";
import { pseudo } from "../../../style/util/pseudo";

const mobileMenuHeight = "8rem";

export const StyledNavigation = styled.div`
  ${zIndex("menu")};
  ${size("100%", mobileMenuHeight)};
  display: block;
  position: fixed;

  &::before {
    ${pseudo()};
    ${size("100%", "130%")};
    top: 0;
    left: 0;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 1) 20%,
      rgba(0, 0, 0, 0.8) 50%,
      rgba(0, 0, 0, 0) 100%
    );
  }

  @media ${device.desktop} {
    position: absolute;
    height: auto;
    top: 0;
    left: 50%;
    max-width: 168rem;
    transform: translateX(-50%);

    &::before {
      display: none;
    }
  }
`;

export const StyledNavigationWrapper = styled.div<{ $isOpen: boolean }>`
  ${size("100%", "100vh")};
  position: absolute;
  transform: translateX(${({ $isOpen }) => ($isOpen ? "0" : "100%")});
  transition: transform 0.35s ${easeOut("quad")};
  background-color: ${({ theme }) => rgba(theme.colors.black, 0.85)};

  @media ${device.desktop} {
    left: 0;
    height: auto;
    transform: none;
    transition: none;
    background-color: transparent;
  }
`;

export const StyledNavigationMenus = styled.ul`
  ${size("100%")};
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  left: 0;
  top: 0;
  padding: 19vh 0 23vh;

  @media ${device.desktop} {
    height: auto;
    flex-direction: row;
    padding: 0 5%;
  }
`;

export const StyledNavigationItem = styled.li`
  position: relative;

  @media ${device.desktop} {
    margin: 7.4rem 0;
    margin: 6.8vh 0;
  }
`;

export const StyledLabel = styled(Paragraph)<{ $isActive?: boolean }>`
  color: ${({ theme, $isActive }) =>
    $isActive ? theme.colors.magenta : theme.colors.offWhite};
  white-space: nowrap;
  font-size: 2.4rem;
  font-weight: 400;
  letter-spacing: 0.25em;
  transition: color 0.3s;

  html:lang(vi) & {
    letter-spacing: 0.05em;
  }

  &::before {
    ${pseudo()};
    width: calc(100% - 0.22em);
    bottom: 0;
    border-bottom: 0.1rem solid;
    transform: scaleX(${({ $isActive }) => ($isActive ? `1` : `0.5`)});
    opacity: ${({ $isActive }) => ($isActive ? `1` : `0`)};
    transition: opacity 0.3s, transform 0.3s ease-out;
  }

  @media ${device.desktop} {
    font-size: 1.8rem;
  }

  @media ${device.desktopL} {
    font-size: 2.4rem;
  }
`;

export const StyledButton = styled(Button)<{ $isActive?: boolean }>`
  ${({ $isActive }) => $isActive && "pointer-events: none;"};

  @media ${hover} {
    &:hover {
      ${StyledLabel} {
        color: ${({ theme }) => theme.colors.magenta};
      }
    }
  }
}
`;

/* Mobile menus */
export const StyledMobileMenuWrapper = styled.div<{ $isOpen?: boolean }>`
  ${size("100%", mobileMenuHeight)};
  ${zIndex("menu")};
  position: absolute;
  top: 0;
  left: 0;
  padding: inherit;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  @media ${device.desktop} {
    display: none;
  }
`;

export const StyledMenuButton = styled(Button)<{ $isOpen?: boolean }>`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.offWhite};
  margin-right: 2.4rem;
`;

export const StyledHomeButton = styled(GlascLogo)<{ $isOpen?: boolean }>`
  ${zIndex("menu")};
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);

  @media ${device.desktop} {
    display: none;
  }
`;

export const StyledDivider = styled(Icon)`
  ${size("3.6rem")};
  color: ${({ theme }) => theme.colors.magenta};

  @media ${device.desktopL} {
    ${size("5rem")};
  }
`;
